import React from 'react';

class Header extends React.Component {
    // constructor(props) {
    //   super(props);
    // }
    render() {
      return (
        <header id="header">
          <nav data-aos="zoom-out" data-aos-delay="800" className="navbar gameon-navbar navbar-expand">
            <div className="container header">
              <a className="navbar-brand" href="https://caesiumlab.com">
                <img src="assets/image/logo.png" alt="" />
              </a>
              <ul className="navbar-nav action">
                <li className="nav-item ml-2">
                  {/* <a href="#" className="btn ml-lg-auto btn-bordered-white"><i className="icon-wallet mr-md-2"></i>Wallet Connect</a> */}
                </li>
              </ul>
            </div>
          </nav>
        </header>
      );
    }
  }

  export default Header;